import React, {
  useState,
  useEffect,
  useRef,
  forwardRef,
  useImperativeHandle,
} from 'react';
import clsx from 'clsx';
import styles from './styles.module.css';

interface DropdownProps extends React.PropsWithChildren {
  button: React.ReactNode;
  variant?: string;
}

export interface DropdownRef {
  close: () => void;
}

export const Dropdown = forwardRef<DropdownRef, DropdownProps>((props, ref) => {
  const [isDropdown, setIsDropdown] = useState(false);
  const dropdownRef = useRef<HTMLDivElement | null>(null);

  const toggleDropdown = () => {
    setIsDropdown(!isDropdown);
  };

  const closeDropdown = () => {
    setIsDropdown(false);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        closeDropdown();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useImperativeHandle(ref, () => ({
    close: closeDropdown,
  }));

  return (
    <div
      className={clsx(
        styles.container,
        props.variant === 'black' && styles.black_border
      )}
      ref={dropdownRef}
    >
      <div
        className={`${styles.dropdown} ${isDropdown ? styles.open : ''}`}
        onClick={(e) => {
          e.stopPropagation();
          toggleDropdown();
        }}
      >
        {props.button}
      </div>
      {isDropdown && (
        <div
          className={clsx(
            styles.content,
            props.variant === 'NoResults' && styles.no_results,
            props.variant === 'black' && styles.black_border
          )}
        >
          {props.children}
        </div>
      )}
    </div>
  );
});

Dropdown.displayName = 'SlotsDropdown';
